import { Nft } from "@/api/nfts/types";
import { useQuery } from "@tanstack/react-query";
import ordersApi from "@/api/orders/client";
import { isEqual } from "@/shared/string";

import { PlaceBidButton } from "../../Buttons/PlaceBid";
import { BaseSignedOrder, ReserveAuctionOrder } from "@/api/orders/types";
import { isExpiredInSeconds } from "@/shared/dates";
import { SettleAuctionButton } from "../../Buttons/SettleAuction";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  nft: Nft;
  auction: BaseSignedOrder;
  disable?: boolean;
}

export default function BuyerReserveActions({ nft, auction, disable }: Props) {
  const { me } = useMe();

  const { data: reserveBids } = useQuery({
    queryKey: ["reserve-bids-for-nft", nft.id],
    queryFn: () => ordersApi.getReserveBidsForNft(nft.id),
  });

  const isHighestBid = (() => {
    if (!reserveBids || !reserveBids?.length) {
      return false;
    }

    return isEqual(reserveBids[0].buyer, me?.address);
  })();

  const isExpired = isExpiredInSeconds(auction.expiresAt!);

  return isExpired && isHighestBid ? (
    <SettleAuctionButton
      auction={auction as ReserveAuctionOrder}
      bid={{ ...reserveBids![0], nft }}
    />
  ) : (
    <PlaceBidButton
      nft={nft}
      auction={auction}
      disable={isHighestBid || isExpired || disable}
    />
  );
}
